import { ColoursObj } from '@eventr/common-storybook'
import i18n from '../../../i18n/i18next'
import { SectionButton } from './sectionButton'

export const AddNewItinButton = () => {
    return (
        <SectionButton
            claimPaths={[`/`]}
            claims={['createItinerary']}
            elementID={'addNewItinerarySection'}
            colour={ColoursObj.core.secondary}
            onClick={() => {
                window.pushPath('/edit/newItin/1/new')
            }}
            icon={'Add'}
            text={i18n.t('edit-itinerary.section-selection.add-new-itin')}
        />
    )
}
